var map = {
	"./E@2x.png": 38,
	"./ENE@2x.png": 39,
	"./ESE@2x.png": 40,
	"./N@2x.png": 41,
	"./NE@2x.png": 42,
	"./NNE@2x.png": 43,
	"./NNW@2x.png": 44,
	"./NW@2x.png": 45,
	"./S@2x.png": 46,
	"./SE@2x.png": 47,
	"./SSE@2x.png": 48,
	"./SSW@2x.png": 49,
	"./SW@2x.png": 50,
	"./W@2x.png": 51,
	"./WNW@2x.png": 52,
	"./WSW@2x.png": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;